/**
 * File navigation.js
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

function initSiteNavigation() {
	const siteNavigation = document.getElementById('site-navigation');

	// Return early if the navigation doesn't exist.
	if (!siteNavigation) {
		return;
	}

	const button = siteNavigation.getElementsByTagName('button')[0];

	// Return early if the button doesn't exist.
	if ('undefined' === typeof button) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName('ul')[0];

	// Hide menu toggle button if menu is empty and return early.
	if ('undefined' === typeof menu) {
		button.style.display = 'none';
		return;
	}

	if (!menu.classList.contains('nav-menu')) {
		menu.classList.add('nav-menu');
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener('click', function() {
		siteNavigation.classList.toggle('toggled');

		if (button.getAttribute('aria-expanded') === 'true') {
			button.setAttribute('aria-expanded', 'false');
		} else {
			button.setAttribute('aria-expanded', 'true');
		}
	});

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener('click', function(event) {
		const isClickInside = siteNavigation.contains(event.target);

		if (!isClickInside) {
			siteNavigation.classList.remove('toggled');
			button.setAttribute('aria-expanded', 'false');
		}
	});

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName('a');

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

	// Toggle focus each time a menu link is focused or blurred.
	for (const link of links) {
		link.addEventListener('focus', toggleFocus, true);
		link.addEventListener('blur', toggleFocus, true);
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for (const link of linksWithChildren) {
		link.addEventListener('touchstart', toggleFocus, false);
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus(event) {
		if (event.type === 'focus' || event.type === 'blur') {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while (!self.classList.contains('nav-menu')) {
				// On li elements toggle the class .focus.
				if ('li' === self.tagName.toLowerCase()) {
					self.classList.toggle('focus');
				}
				self = self.parentNode;
			}
		}

		if (event.type === 'touchstart') {
			const menuItem = this.parentNode;
			event.preventDefault();
			for (const link of menuItem.parentNode.children) {
				if (menuItem !== link) {
					link.classList.remove('focus');
				}
			}
			menuItem.classList.toggle('focus');
		}
	}
}

/**
 * Mobile Navigation Handler
 */
function initMobileNavigation() {
	const menuToggle = document.querySelector('.menu-toggle-movil');
	const menuOverlay = document.querySelector('.menu-overlay');
	const closeButton = document.querySelector('.outer-close .close');
	
	if (menuToggle && menuOverlay) {
		// Open mobile menu
		menuToggle.addEventListener('click', function() {
			menuOverlay.classList.add('active');
			menuToggle.classList.add('active');
			document.body.style.overflow = 'hidden'; // Prevent background scrolling
		});
		
		// Close mobile menu
		const closeMenu = function() {
			menuOverlay.classList.remove('active');
			menuToggle.classList.remove('active');
			document.body.style.overflow = ''; // Restore scrolling
		};
		
		// Close button click
		if (closeButton) {
			closeButton.addEventListener('click', closeMenu);
		}
		
		// Close on overlay click (outside menu items)
		menuOverlay.addEventListener('click', function(e) {
			if (e.target === menuOverlay) {
				closeMenu();
			}
		});
		
		// Close on escape key
		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape' && menuOverlay.classList.contains('active')) {
				closeMenu();
			}
		});
		
		// Smooth scroll for mobile menu links
		const mobileMenuLinks = menuOverlay.querySelectorAll('a[href^="#"]');
		mobileMenuLinks.forEach(link => {
			link.addEventListener('click', function(e) {
				const targetId = this.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);
				
				if (targetElement) {
					e.preventDefault();
					closeMenu();
					
					// Smooth scroll to target
					setTimeout(() => {
						targetElement.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
					}, 300);
				}
			});
		});
	}
	
	// Add scroll effect to header
	const header = document.querySelector('.site-header');
	if (header) {
		window.addEventListener('scroll', function() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			
			if (scrollTop > 100) {
				header.classList.add('scrolled');
			} else {
				header.classList.remove('scrolled');
			}
		});
	}
}

/**
 * Smooth scrolling for home page hero buttons
 */
function initSmoothScrolling() {
	const heroButtons = document.querySelectorAll('.hero-cta a[href^="#"]');
	
	heroButtons.forEach(button => {
		button.addEventListener('click', function(e) {
			const targetId = this.getAttribute('href').substring(1);
			const targetElement = document.getElementById(targetId);
			
			if (targetElement) {
				e.preventDefault();
				
				// Calculate offset to account for fixed header
				const headerOffset = 80;
				const elementPosition = targetElement.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
				
				// Smooth scroll to target element
				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				});
			}
		});
	});
}

function init() {
	initSiteNavigation();
	initMobileNavigation();
	initSmoothScrolling();
}

export default init;
